export const transitionEasing = 'cubic-bezier(0.16, 1, 0.3, 1)';
export const transitionDuration = '0.5s';
export const transitionString = `${transitionDuration} ${transitionEasing}`;

